<rid-demo-page [title]="'Component Lab'" previousRoute="/">
  <rid-button class="w-full" content="<rid-button>" routerLink="button" variant="PRIMARY" />
  <rid-button class="w-full" content="<rid-content-card>" routerLink="content-card" variant="PRIMARY" />
  <rid-button class="w-full" content="<rid-egg-carton>" routerLink="egg-carton" variant="PRIMARY" />
  <rid-button class="w-full" content="<rid-egg-cartons>" routerLink="egg-cartons" variant="PRIMARY" />
</rid-demo-page>
